import { useCallback, useMemo, useState } from 'react';
import type { FeedbackSeverity, FeedbackState } from './types';

export const useTimelineFeedback = (): FeedbackState => {
  const [value, setValue] = useState<{ message: string; severity: FeedbackSeverity } | null>(
    null
  );

  const show = useCallback((message: string, severity: FeedbackSeverity) => {
    setValue({ message, severity });
  }, []);

  const clear = useCallback(() => {
    setValue(null);
  }, []);

  return useMemo<FeedbackState>(
    () => ({
      value,
      show,
      clear,
    }),
    [clear, show, value]
  );
};
